import { HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';

export class HttpBasicRequest {
  url: string;
  method: 'get' | 'post' | 'put' | 'delete';
  body?: any;
  options?: HttpBasicRequestOptions;
  parentId?: number;

  constructor(init?: Partial<HttpBasicRequest>) {
    Object.assign(this, init);
    if (!this.options) this.options = {};
  }
}

export class HttpBasicRequestOptions {
  headers?: HttpHeaders | { [header: string]: string | string[]; };
  observe?: 'body';
  params?: HttpParams | { [param: string]: any | any[]; };
  responseType?;

  constructor(init?: Partial<HttpBasicRequestOptions>) {
    Object.assign(this, init);
    if (!this.responseType) this.responseType = 'json';
    if (!this.observe) this.observe = 'body';
  }
}

export class HttpBasicTextRequestOptions {
  headers?: HttpHeaders | {
    [header: string]: string | string[];
  };
  context?: HttpContext;
  observe?: 'body';
  params?: HttpParams | {
    [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
  };
  reportProgress?: boolean;
  responseType: 'text';
  withCredentials?: boolean;

  constructor(init?: Partial<HttpBasicRequestOptions>) {
    Object.assign(this, init);
    if (!this.responseType) this.responseType = 'text';
    if (!this.observe) this.observe = 'body';
  }
}
